module.exports = __webpack_public_path__ + "img/product-7-INTguanhuai.f01c1e34.png";